import { AppState } from 'Store'

export const leadUiSelector = {
	selectAgreementState: (state: AppState) => state.new_leads.leadUi.agreementState,
}
